const Nfts = () => {
    return ( 
        <div class="home_bored_bunny">
            <div class="container">
                <div class="row introducing">
                    <div class="col col-lg-12 col-md-12 col-sm-12">
                        <h3>Introducing:</h3> 
                        <h4>Series 1: Crypto Pilot</h4>
                        <h5>The Universal Space Station is a collection of 2222 Crypto Pilots NFTs orbiting the Earth on the Ethereum blockchain ERC-721. They are your passport to exclusive perks, staking, tokens, community wallet, earnings, IP rights, Metaverse, events, CP Swap, and more. Each Crypto Pilot is unique and algorithmically generated from over 100 traits, some are rarer than others. 10% profits to our official charity.</h5>
                    </div>
                </div>
            </div>
            <div class="home_bored_bunny_max">
                <div class="home_bored_bunny_flex">
                    <div class="home_bored_bunny_inner">
                        <div class="home_bored_bunny_img">    
                            <img src="images/4.png" title="" alt="" width="100%" class="hover_hide"/>
                            <img src="images/8.png" title="" alt="" width="100%" class="hover_show"/>
                        </div>
                    </div>
                    <div class="home_bored_bunny_inner">
                        <div class="home_bored_bunny_img">    
                            <img src="images/65.png" title="" alt="" width="100%" class="hover_hide"/>
                            {/* <img src="images/97.png" title="" alt="" width="100%" class="hover_show"/> */}
                            <img src="images/693.png" title="" alt="" width="100%" class="hover_show"/>
                        </div>
                    </div>
                    <div class="home_bored_bunny_inner">
                        <div class="home_bored_bunny_img">    
                            <img src="images/13.png" title="" alt="" width="100%" class="hover_hide"/>
                            <img src="images/14.jpg" title="" alt="" width="100%" class="hover_show"/>
                        </div>
                    </div>
                    <div class="home_bored_bunny_inner">
                        <div class="home_bored_bunny_img">    
                            <img src="images/98.png" title="" alt="" width="100%" class="hover_hide"/>
                            <img src="images/99.jpg" title="" alt="" width="100%" class="hover_show"/>
                        </div>
                    </div>
                </div>
                <div class="home_bored_text aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                    <h3>Crypto Pilots</h3>
                </div>
            </div>
        </div>
      );
}
 
export default Nfts;